<style >
.diglog_h {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  padding: 24px 24px 0 24px;
  color: #1a1a1a;
}
.diglog_icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>

<template>
  <!-- 绑定手机对话框 -->
  <el-dialog
      :visible.sync="dialogVisible"
      width="500px" :show-close="false"
      :close-on-click-modal="false"
      @close="resetForm">
    <div class="diglog_h">
      <div>绑定手机号</div>
      <img
          src="@/assets/structure/close.png"
          class="diglog_icon"
          @click="resetForm"
      />
    </div>
    <div style="margin-top: 10px;padding: 20px">
      <el-form  class="form_method"
          :model="bindForm"
          :rules="formRules"
          ref="bindFormRef"
          label-width="80px">
        <el-tabs v-model="activeName">
          <el-tab-pane label="绑定邮箱" name="email">
            <div v-if="activeName == 'email'" style="padding-top: 10px;">
              <el-form-item label="邮箱" prop="email" >
                <el-input
                    v-model="bindForm.email"
                    placeholder="请输入邮箱"
                    maxlength="64"
                    clearable>
                </el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="code"  style="margin-top: 30px">
                <el-input
                    v-model="bindForm.code"
                    placeholder="请输入6位验证码"
                    maxlength="6"
                    clearable
                    style="width: 55%; margin-right: 10px;">
                </el-input>
                <el-button
                    type="primary"
                    :disabled="countdownEmail > 0 || !isValidEmail"
                    @click="sendCode"
                    class="countdown-btn"
                    style="width: 40%;">
                  {{ countdownEmailText }}
                </el-button>
              </el-form-item>
            </div>
          </el-tab-pane>
          <el-tab-pane label="绑定手机" name="phone">
            <div v-if="activeName == 'phone'" style="padding-top: 10px;">
              <el-form-item label="手机号码" prop="phone" >
                <el-input
                    v-model="bindForm.phone"
                    placeholder="请输入11位手机号码"
                    maxlength="11"
                    clearable>
                  <template slot="prepend">+86</template>
                </el-input>
              </el-form-item>

              <el-form-item label="验证码" prop="code"  style="margin-top: 30px">
                <el-input
                    v-model="bindForm.code"
                    placeholder="请输入6位验证码"
                    maxlength="6"
                    clearable
                    style="width: 55%; margin-right: 10px;">
                </el-input>
                <el-button
                    type="primary"
                    :disabled="countdown > 0 || !isPhoneValid"
                    @click="sendCode"
                    class="countdown-btn"
                    style="width: 40%;">
                  {{ countdownText }}
                </el-button>
              </el-form-item>
            </div>
          </el-tab-pane>

        </el-tabs>
      </el-form>
      <el-button
          type="primary"
          @click="submitBindForm"
          :loading="submitting"
          style="width: 100%;margin-top: 30px">
        确认绑定
      </el-button>
    </div>
  </el-dialog>
</template>


<script>
import http from "@/utils/http";
import md5 from "@/utils/md5Util";
import {WechatOpenOauthApi} from "@/api/server/wechatOpenOauth";

export default {
  components: {},
  data() {
    // 验证手机号规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('手机号码格式不正确'));
      } else {
        callback();
      }
    };

    // 验证验证码规则
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'));
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error('验证码为6位数字'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      activeName: 'email',
      submitting: false,
      // 倒计时秒数
      countdown: 0,
      countdownEmail: 0,
      // 倒计时定时器
      countdownTimer: null,
      countdownEmailTimer: null,
      // 绑定表单数据
      bindForm: {
        phone: '',
        email: '',
        code: ''
      },
      // 表单验证规则
      formRules: {
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'},
          { required: true, message: '请输入邮箱地址', trigger: 'blur'},
        ],
        code: [
          { required: true, validator: validateCode, trigger: 'blur' }
        ]
      }
    };
  },
  created() {

  },
  mounted() {

  },
  computed: {
    // 手机号是否有效
    isPhoneValid() {
      return /^1[3-9]\d{9}$/.test(this.bindForm.phone);
    },
    isValidEmail() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(this.bindForm.email);
    },
    // 倒计时文本
    countdownText() {
      if (this.countdown > 0) {
        return `${this.countdown}秒后重新获取`;
      }
      return '获取验证码';
    },
    countdownEmailText() {
      if (this.countdownEmail > 0) {
        return `${this.countdownEmail}秒后重新获取`;
      }
      return '获取验证码';
    }
  },
  methods: {
    // 打开绑定对话框
    open(data) {
      this.bindForm = Object.assign(this.bindForm,data);
      // 如果已有手机号，预填当前手机号
      this.dialogVisible = true;
      console.log(this.bindForm)
    },
    // 发送验证码
    sendCode() {
      // 验证手机号
      if (this.activeName == 'phone' && !this.isPhoneValid) {
        this.$message.error('请输入正确的手机号码');
        return;
      }else if(this.activeName == 'email' && !this.isValidEmail){
        this.$message.error('请输入邮箱');
      }
      if(this.countdownTimer){
        clearInterval(this.countdownTimer);
      }
      if(this.countdownEmailTimer){
        clearInterval(this.countdownEmailTimer);
      }
      let data = {}
      if(this.activeName == 'phone'){
        data = {phone: this.bindForm.phone, code: this.bindForm.code,ticket: md5(this.bindForm.phone),getCodeType: "ACCOUNT_BIND"};
      }else{
        data = {email: this.bindForm.email, code: this.bindForm.code,ticket: md5(this.bindForm.email),getCodeType: "ACCOUNT_BIND"};
      }
      http.get("/umsSysUser/code_get", data).then((res) => {
            if (res.code == 200) {
              // 模拟发送验证码请求
              this.$message.success(`验证码已发送到 ${this.bindForm.phone || this.bindForm.email}`);

              if(this.activeName == 'phone'){
                // 开始倒计时
                this.countdown = 60;
                this.countdownTimer = setInterval(() => {
                  if (this.countdown > 0) {
                    this.countdown--;
                  } else {
                    clearInterval(this.countdownTimer);
                    this.countdownTimer = null;
                  }
                }, 1000);
              }else{
                // 开始倒计时
                this.countdownEmail = 60;
                this.countdownEmailTimer = setInterval(() => {
                  if (this.countdownEmail > 0) {
                    this.countdownEmail--;
                  } else {
                    clearInterval(this.countdownEmailTimer);
                    this.countdownEmailTimer = null;
                  }
                }, 1000);
              }

            } else {
              this.$message.error(res.message);
            }
          });

    },

    // 提交绑定表单
    submitBindForm() {
      this.$refs.bindFormRef.validate((valid) => {
        if (!valid) {
          this.$message.error('请填写正确的表单信息');
          return;
        }

        // 模拟提交过程
        this.submitting = true;
        const data = Object.assign({}, this.bindForm);
        if(this.activeName == 'phone'){
          delete data.email;
        }else{
          delete data.phone;
        }
        WechatOpenOauthApi.binding(data).then( res => {
          if (res.code == 200) {
            this.$message.success('绑定成功');
            this.$emit('success',this.bindForm);
            this.dialogVisible = false;
          } else {
            this.$message.error(res.message);
          }
        }).finally(() => {
          this.submitting = false;
        })

      });
    },

    // 重置表单
    resetForm() {
      this.$refs.bindFormRef.resetFields();
      this.bindForm.phone = '';
      this.bindForm.code = '';

      // 清除倒计时
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdown = 0;
      this.dialogVisible = false;
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
};
</script>